import { useTranslation } from 'react-i18next'
import CardTemplate from './card-template'
import unknown from './images/unknown.svg'

const InternationalUser = ({ children, ...props }) => {
  const { t } = useTranslation()

  const creditDescription =
    props.userRole === 'tenant'
      ? t(
          'r.liv_score_card.view.international_user_description.text',
          `Your Trust Score can not be determined. This is because you indicated that you don't have credit history in Canada.`
        )
      : t(
          'l.liv_score_card.view.international_user_description.text',
          `This applicant's Trust Score can not be determined. This is because they have indicated that they don't have credit history in Canada. Please refer to the additional documents provided by the applicant below.`
        )

  return (
    <CardTemplate
      userRole={props.userRole}
      title={props.title}
      creditDetails={{ ...props.creditDetails, credit_rating: 'not enough' }}
      creditDescription={creditDescription}
      creditRatingResult={t('b.liv_score_card.view.not_enough_info.text', 'Not Enough Info')}
      cardImage={unknown}
      user={props.user}
      professionId={props.professionId}
      csoVerifiedState={props.csoVerifiedState}
      salarySort={props.salarySort}
      listingData={props.listingData}
      showDetails={props.showDetails}
      secureFiles={props.secureFiles}
      noDetails
      data-testid={props['data-testid']}
    >
      {children}
    </CardTemplate>
  )
}

InternationalUser.defaultProps = {
  userRole: 'tenant',
  title: ''
}

export default InternationalUser
